import React from "react";
import { IconNodataSearch } from "../../../assets/icon";
import TranslateText from "../TranslateText";
import "../../../assets/style/featuresStyle/noresults.scss";
const NoSearchResults = () => {
  return (
    <div className="wrapperNoResult">
      <IconNodataSearch />
      <span className="text">
        <TranslateText text={"Không tìm thấy kết quả"} />
      </span>
    </div>
  );
};

export default NoSearchResults;
